import React from 'react';

const NorthDakota = () => (
  <svg
    width="89"
    height="55"
    viewBox="0 0 89 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80.5027 4.11213C80.7562 5.51327 80.8618 6.52716 81.0167 7.69594C81.2349 9.35759 80.897 10.7165 81.0167 13.8426C81.0308 14.3003 81.6503 14.6242 81.5306 15.3776C81.3264 16.652 81.8404 19.7218 82.5514 22.0312C83.1217 23.8689 84.2833 25.3404 84.6001 27.1499C84.762 28.1075 84.0862 28.9946 84.0862 29.1988C84.0862 30.0156 84.9943 32.9798 85.107 34.8315C85.1703 35.9229 84.5649 36.1834 84.5931 36.8804C84.6071 37.1761 84.8254 40.8163 85.107 42.5131C85.2478 43.3721 85.283 44.6606 85.6209 45.583C85.8462 46.1955 86.9797 46.9911 87.1557 47.6319C87.733 49.6948 87.3809 51.7437 88.1765 53.7785C58.8754 55.0952 28.8281 52.7224 0.639404 51.2157C2.23048 34.5499 2.3924 16.4478 4.73677 0.52832C28.7296 2.98559 55.7426 2.42232 80.5027 4.11213Z"
      fill="#FC374D"
    />
  </svg>
);

export default NorthDakota;
